export default __webpack_public_path__ + "static/the-core-collection-banner-mobile-540a64a304946a94d26126ae64779f2b.webp";